import { render, staticRenderFns } from "./ModalRedirecionamento.vue?vue&type=template&id=a9be0230&lang=html"
import script from "./ModalRedirecionamento.vue?vue&type=script&lang=js"
export * from "./ModalRedirecionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports